import { DOAbnormalOperationUserBean } from "./do-abnormal-operation-user-bean";
import { DOAbnormalTableHeaderUpdateBean } from "./do-abnormal-table-header-update-bean";

export class DOAbnormalTableHeaderUpdateRequest extends DOAbnormalOperationUserBean {
  updatedHeaders: DOAbnormalTableHeaderUpdateBean[];

  constructor() {
    super();
    this.updatedHeaders = [];
  }
}
